/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Tracking Filter Icon component.
 */
export const TrackingFilterIcon = ({
  color = dlsColor('grey1'),
  ...props
}: IconProps) => {
  const {iconSize, iconColor} = useIconDLS({...props, color});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M17.6003 6.73811C17.7807 6.40496 17.5395 6 17.1606 6H5.8394C5.46053 6 5.21931 6.40496 5.39974 6.73811L9.10633 13.5823C9.14593 13.6554 9.16667 13.7373 9.16667 13.8204V17.1875C9.16667 17.4069 9.30959 17.6006 9.51915 17.6653L13.1941 18.8001C13.5158 18.8994 13.8417 18.6589 13.8417 18.3223V13.6968C13.8417 13.6951 13.8403 13.6937 13.8386 13.6937C13.8362 13.6937 13.8347 13.6912 13.8358 13.6891L17.6003 6.73811Z' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default TrackingFilterIcon;
